import {Component, computed, inject, input} from '@angular/core';
import {AvatarGroup} from 'primeng/avatargroup';
import {Avatar} from 'primeng/avatar';
import {Tooltip} from 'primeng/tooltip';
import {Router} from '@angular/router';
import {ProjectStepStateService} from '../../../../project-sequence/project-step-state.service';
import {
  ProjectRoleAccessDirective,
  ProjectRoleConfig,
} from '../../../../../../shared/directives/project-role-access.directive';
import {ProjectRoleConfigService} from '../../../../../../shared/services/project-role-config.service';
import {SPECIAL_OPTION_IDS} from '../../../../project-sequence/project-step-state.constants';
import {APP_ROUTES} from '../../../../../../app.routes';

export interface AvatarUser {
  fullName: string;
  avatarUrl?: string;
}

@Component({
  selector: 'app-user-avatar-group',
  imports: [AvatarGroup, Avatar, Tooltip, ProjectRoleAccessDirective],
  templateUrl: './user-avatar-group.component.html',
})
export class UserAvatarGroupComponent {
  private readonly router = inject(Router);
  private readonly stepState = inject(ProjectStepStateService);
  private readonly roleConfigService = inject(ProjectRoleConfigService);

  readonly users = input<AvatarUser[]>([]);
  readonly projectId = input<number>();

  getInitial(name: string): string {
    return name.charAt(0).toUpperCase();
  }

  navigateToUserManagement() {
    const projectId = this.projectId();
    if (projectId) {
      this.stepState.setActiveSpecialOption(SPECIAL_OPTION_IDS.USER_MANAGEMENT);
      this.router.navigate([APP_ROUTES.PROJECT, projectId, APP_ROUTES.STEPS]);
    }
  }

  protected readonly projectManagementConfig = computed((): ProjectRoleConfig | null => {
    return this.roleConfigService.createProjectManagerWithTenantAdminConfigOrNull(this.projectId());
  });
}
